import { render, staticRenderFns } from "./BulkEmbedConfirm.vue?vue&type=template&id=2824ea2e&scoped=true&"
import script from "./BulkEmbedConfirm.vue?vue&type=script&lang=js&"
export * from "./BulkEmbedConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BulkEmbedConfirm.vue?vue&type=style&index=0&id=2824ea2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2824ea2e",
  null
  
)

export default component.exports